import { requestSuspender } from 'serviceWorker/api/RequestSuspender';
import flush from 'serviceWorker/db/flush';
import { publishEvent } from 'serviceWorker/broadcasts/publishers';
import { swSignals } from 'serviceWorker/events/swSignals';
import { dataFlushContract } from 'shared/domain/dataFlush/dataFlushContract';
import { logoutContract } from 'shared/domain/logout/logoutContract';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { swLog } from 'serviceWorker/helpers/makeSwLogger';
import { LogLevel } from 'shared/types/logger';

let logoutInProgress: Promise<void> | null = null;

async function runLogout(): Promise<void> {
  const startedAt = Date.now();
  requestSuspender.suspend();
  try {
    swSignals.loggedOut.emit();
    publishEvent(logoutContract, DomainMessagesTypes.logout, undefined);

    await flush();
    publishEvent(dataFlushContract, DomainMessagesTypes.dataFlushed, undefined);

    debugLog('SW logout finished', { durationMs: Date.now() - startedAt });
  } finally {
    requestSuspender.resume();
  }
}

/**
 * Signs the user out in the worker: tells every tab, drops the user's data and
 * resolves once it is dropped. A second request while one runs gets the same.
 */
export function logOutAndFlush(): Promise<void> {
  logoutInProgress ??= runLogout().finally(() => {
    logoutInProgress = null;
  });
  return logoutInProgress;
}

/** Signs the user out when the API rejects the session (401 from a pull). */
export function init(): void {
  swSignals.unauthorizedResponse.subscribe(({ url, method }) => {
    void logOutAndFlush().catch((logoutError: unknown) => {
      swLog('SW logout failed after 401', LogLevel.ERROR, logoutError, { query: { url, method } });
    });
  });
}
